import { render, staticRenderFns } from "./Trivia17.vue?vue&type=template&id=54416dd6&"
import script from "./Trivia17.vue?vue&type=script&lang=js&"
export * from "./Trivia17.vue?vue&type=script&lang=js&"
import style0 from "./Trivia17.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports